import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { faTimes as removeDiscountIcon } from "@fortawesome/pro-light-svg-icons/faTimes";

import { Button, getTheme, IconButton, Loader } from "components/UI";

import Color from "utils/Color";
import { addProp, getProp } from "utils/Utils";

import translationStore from "stores/translation-store";

import getStyle from "./style";

function DiscountInput(props, ref)
{
  const inputRef = useRef();
  const [internalValue, setInternalValue] = useState(null);
  const [hasFocus, setFocus] = useState(false);
  const [isVisible, setVisible] = useState(false);

  const onFocus = () => setFocus(true);
  const onBlur = e => {
    if(props.onBlur)
      props.onBlur(e);

    setFocus(false)
  };

  const onChange = value =>
  {
    const endsWithDash = value.endsWith("-");

    if(value.length > 0)
    {
      value = value.replaceAll("-", "");
      value = value.match(/.{1,3}/g).join("-");
      value = value.toUpperCase();
      if(endsWithDash)
        value += "-";
    }

    addProp(props.errorFields, ['code'], false);
    setInternalValue(value);
  }

  const onKey = e =>
  {
    if(e.key.toLowerCase() === "enter")
    {
      props.onSave(e.target.value);
      setInternalValue(null);
    }
  }

  const getValue = () =>
  {
    if(internalValue !== undefined && internalValue !== null)
      return internalValue;
    return props.value || "";
  }

  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current.focus();
    }
  }));

  const hasCodeSet = (props.value === getValue() && props.value !== "");
  const hasError = (getProp(props.errorFields, ['code']) === true);
  const styles = getStyle(isVisible);

  const classes = [
    styles.className,
    "discount-input",
    hasFocus ? "active" : "",
    hasError ? "error" : ""
  ]

  if(hasCodeSet && !hasError && !props.loading)
  {
    return (
      <div className={`${styles.className} discount-input filled`}>
        <span style={{marginRight: 10}}>{translationStore.translate("shop.cart.discount.placeholder")}: {getValue()}</span>
        <IconButton
          icon={removeDiscountIcon}
          style={{
            color: "rgba(var(--accentColorDark), 1)"
          }}
          onClick={() => props.onSave("")}
        />
        {styles.styles}
      </div>
    )
  }

  return (
    <div className={classes.join(" ")}>
      {
        !isVisible &&
        <div className={`${styles.className} link`} onClick={() => setVisible(true)}>
          {translationStore.translate("shop.cart.discount.appear-link")}
        </div>
      }
      <input
        className={`${styles.className}`}
        type={"text"}
        ref={inputRef}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={e => onChange(e.target.value)}
        onKeyDown={onKey}
        value={getValue()}
        enterKeyHint="send"
        maxLength={19}
        readOnly={hasCodeSet && !hasError}
        placeholder={translationStore.translate("shop.cart.discount.placeholder").toUpperCase()}
      />
      <Button
        className={`${styles.className} discount-apply`}
        style={{
          color: `#${Color.rgbToHex(getTheme().accentColorDark)}`
        }}
        onClick={() => props.onSave(getValue())}
      >
        {
          props.loading ?
          <Loader
            foregroundColor="rgba(var(--backgroundColor), 1)})"
            backgroundColor="rgba(var(--backgroundColor), .5)})"
          /> :
          translationStore.translate("shop.cart.discount.apply")
        }
      </Button>
      {styles.styles}
    </div>
  );
}

export default forwardRef(DiscountInput);